import { Degree, Gender } from "../enums";
import { ImageUrl } from "../value-objects";
import { AddressVO } from "./address.types";
import { IEntityBase } from "./entity-base.types";
import { IJobResponse } from "./job.types";
import { EmploymentResponse } from "./employment.types";

export enum WebAppRole {
  admin = "Administrador",
  manager = "Gerente",
  collaborator = "Colaborador",
  user = "User",
  guest = "Invitado",
}

export interface ICollaboratorBase {
  id?: string;
  // Primary data
  // todo remove this
  _id?: string;
  first_name: string;
  last_name: string;
  email?: string;
  col_code: string;
  role: WebAppRole;
  isActive: boolean;
  isDisplayedWeb: boolean;

  // General information
  gender?: Gender;
  birthDate?: Date;
  degree?: Degree;
  phoneNumber?: string;
  phoneNumber2?: string;
  address?: AddressVO;
  curp?: string;
  imssNumber?: string;
  rfcCode?: string;
  // CFDI/Fiscal data
  taxZipCode?: string;
  contractType?: string;
  fiscalRegime?: string;
  bank?: string;
  bankAccount?: string;
  emergencyContact?: string;
  emergencyContactPhone?: string;

  // webApp information
  images?: ImageUrl[];
  password?: string;
  textPresentation?: string;
  // TODO: remove this
  lastLogin?: Date;

  // Job information
  // this could be computed
  startDate?: Date;
  endDate?: Date;
  contractDate?: Date;
  imssEnrollmentDate?: Date;

  // QVET integration
  qvetAliases?: string[];

  // TODO: enum
}

export interface ICollaborator extends ICollaboratorBase, IEntityBase {
  id: string;
}

export interface ICollaboratorWithJobAndEmployment {
  collaborator: ICollaborator;
  job: IJobResponse;
  employment: EmploymentResponse;
}
